<main class="logged-out">
  <section class="logged-out-card">
    <h1>You are logged out</h1>
    <p>
      The local Blankmile session has been ended. Sign in again when you want to
      continue.
    </p>
    <button mat-flat-button color="primary" type="button" (click)="login()">
      Sign in
    </button>
  </section>
</main>
